/* template */
<template minapp="mpx" xlang="wxml"><div class="mpx-root-view"><div :style="[(beforeDirective)] | transRpxStyle" class="recommend"><div class="left">{{ recommendTicket.tips }}<div class="gap"></div>{{ recommendTicket.plan }}<span class="price">{{ recommendTicket.price }}</span><span class="station">{{ recommendTicket.diffStationNum }}</span></div><mpx-view @tap="click" class="right">详情</mpx-view></div><recommend-ticket-drawer :show="(showDrawer)" @close="closeDrawer" :trainInfo="(trainInfo)" :recommendTicketDrawer="(recommendTicketDrawer)"/></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"me4675b46"}'>
  @import '~@/mixins/stylus/color.styl'
  :root
    --left:30px
  .recommend
    height 32px
    background #EEF5FF
    margin 10px -15px -13px -15px
    border-radius 0 0 16px 16px
    display flex
    justify-content space-between
    font-size 11px
    color #333333
    align-items center
    padding 0 26px 0 16px
    position relative
    &::before
      content ''
      position absolute
      border-left 8px solid transparent
      border-right 8px solid transparent
      border-bottom 8px solid #EEF5FF
      left var(--left)
      top -6px
  .left
    display flex
    align-items center
  .right
    position relative
    &::after
      content ''
      position absolute
      border-top 1px solid
      border-right 1px solid
      width 4px
      height 4px
      transform rotate(45deg)
      top 5px
  .gap
    background #CCCCCC
    width 1px
    height 10px
    margin 0.5px 8px
  .price
    color #FF6400
    font-weight 800
  .station
    color #338FFF
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "me4675b46"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findexe4675b46%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findexe4675b46%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["me4675b46"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/indexe4675b46/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'recommend-ticket-drawer':getComponent(require("./drawer.mpx?isComponent&outputPath=components%2Fdrawer1b229ef4%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
